module.exports = __webpack_public_path__ + "img/intj.028bde5d.png";